import { render, staticRenderFns } from "./MEM_highLights.vue?vue&type=template&id=0f43525a&"
import script from "./MEM_highLights.vue?vue&type=script&lang=js&"
export * from "./MEM_highLights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports